const resources = {
    giftCardTitle: 'Gift Card',
    free: 'Free',
    giftCardSubtitle: 'Your gift card will be shipped to this address.'
};

export default function getResource(label) {
    return resources[label];
}
